import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeWhile } from "rxjs/operators";
import { interval } from "rxjs";

import {
    FvmsApiAuthService
} from "src/app/shared/service";

@Component({
    templateUrl: "./auth.reset.pw.modal.component.html"
    ,styleUrls: ["./auth.reset.pw.modal.component.scss"]
})
export class AuthResetPasswordModalComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    activeTabId:number = 1;
    fgRequest:FormGroup;
    fgCheck:FormGroup;
    fgNewPw:FormGroup;
    submittedRequest:boolean = false;
    submittedCheck:boolean = false;
    submittedNewPw:boolean = false;
    isSentAuthKey:boolean = false;
    isAuthKeyOk:boolean = false;
    readonly dateLimit:number = 1000 * 60 * 5; // 인증 제한 5분
    dateFrom:number = 0;
    requestFailMessage:string;
    checkFailMessage:string;
    newPwFailMessage:string;

    constructor(
        public activeModal: NgbActiveModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) { }

    ngOnInit() {
        this.initFormRequest();
        this.initFormCheck();
        this.initFormNewPw();
    }

    initFormRequest(){
        this.fgRequest = this.formBuilder.group({
            userId:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,authType:[
                "1"
                ,[
                    Validators.required
                ]
            ]
            ,authTo:[
                ""
                ,[
                    Validators.required
                ]
            ]
        });
        this.requestFailMessage = "";
    }

    initFormCheck(){
        this.fgCheck = this.formBuilder.group({
            authKey:[
                ""
                ,[
                    Validators.required
                ]
            ]
        });
        this.checkFailMessage = "";
    }

    initFormNewPw(){
        this.fgNewPw = this.formBuilder.group({
            userPw:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,userPw2:[
                ""
                ,[
                    Validators.required
                ]
            ]
        }
        ,{
            validator:this.checkPwMatch("userPw","userPw2")
        });
    }

    checkPwMatch(f1:string, f2:string){
        return (formGroup: FormGroup) => {
            let field1 = formGroup.controls[f1];
            let field2 = formGroup.controls[f2];

            if(field2.errors && !field2.errors.mismatch){
                return;
            }

            let isMatch = field1.value === field2.value;
            if(isMatch === true){
                field2.setErrors(null);
            }else{
                field2.setErrors({"mismatch":true});
            }
        };
    }

    get fReq() { return this.fgRequest.controls; }
    get fCheck() { return this.fgCheck.controls; }
    get fNewPw() { return this.fgNewPw.controls; }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {}

    clickCancel(){
        this.activeModal.close({
            "type":"cancel"
        });
    }

    onSubmitRequest(){
        this.submittedRequest = true;
        if (this.fgRequest.invalid) {
            return;
        }

        let searchInfo = {
            userId:this.fReq.userId.value
            ,authType:this.fReq.authType.value
            ,authTo:this.fReq.authTo.value
            ,createUser:this.fReq.userId.value
            ,updateUser:this.fReq.userId.value
        };
        this.fvmsApiAuthService.requestUserPwReset(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.isSentAuthKey = true;
                    this.requestFailMessage = "";
                    this.initFormCheck();
                    this.initAuthTimeLimit();
                    interval(1000)
                        .pipe(takeWhile(() => this.isContinue))
                        .pipe(takeWhile(() => this.isSentAuthKey))
                        .subscribe(() => this.queueAuthTimeLimit());
                }else{
                    this.isSentAuthKey = false;
                    this.initFormCheck();
                    this.requestFailMessage = apiResponse.resultMessage;
                }
            });
    }

    initAuthTimeLimit(){
        this.dateFrom = this.dateLimit;//인증 5분 제한
    }

    queueAuthTimeLimit(){
        this.dateFrom -= 1000;
        if(this.dateFrom <= 0) {
            // 시간초과
            this.isSentAuthKey = false;
            this.initFormCheck();
        }
    }

    getAuthTimeLimit(){
        return new Date(this.dateFrom);
    }

    onSubmitCheck(){
        this.submittedCheck = true;
        if (this.fgCheck.invalid) {
            return;
        }

        let searchInfo = {
            userId:this.fReq.userId.value
            ,authType:this.fReq.authType.value
            ,authTo:this.fReq.authTo.value
            ,authKey:this.fCheck.authKey.value
            ,createUser:this.fReq.userId.value
            ,updateUser:this.fReq.userId.value
        };
        this.fvmsApiAuthService.checkUserPwReset(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.isAuthKeyOk = true;
                }else{
                    this.checkFailMessage=apiResponse.resultMessage;
                }
            });
    }

    onSubmitNewPw(){
        this.submittedNewPw = true;
        if (this.fgNewPw.invalid) {
            return;
        }

        let searchInfo = {
            userId:this.fReq.userId.value
            ,userPw:this.fNewPw.userPw.value
            ,createUser:this.fReq.userId.value
            ,updateUser:this.fReq.userId.value
        };
        this.fvmsApiAuthService.resetUserPw(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.initFormRequest();
                    this.initFormCheck();
                    this.initFormNewPw();
                    this.submittedRequest = false;
                    this.submittedCheck = false;
                    this.submittedNewPw = false;
                    this.isSentAuthKey = false;
                    this.isAuthKeyOk = false;
                    this.requestFailMessage = "변경 되었습니다";
                }else{
                    this.newPwFailMessage = apiResponse.resultMessage;
                }
            });
    }
}